import {IItem} from '../../select';

export const DEFAULT_MODEL: string = 'gpt-3.5-turbo';

export const MODEL_OPTIONS: IItem[] = [
  {
    label: DEFAULT_MODEL,
    value: DEFAULT_MODEL,
  },
  {
    label: 'gpt-4',
    value: 'gpt-4'
  },
  {
    label: 'gpt-4o',
    value: 'gpt-4o'
  },
  {
    label: 'gpt-4o-mini',
    value: 'gpt-4o-mini'
  },
  {
    label: 'gpt-4-turbo',
    value: 'gpt-4-turbo'
  },
];
